import Project1 from "../../assets/project_todo.png";
import Project2 from "../../assets/project_jogo-numero-secreto.png";
import Project3 from "../../assets/project_race.png";
import Project4 from "../../assets/project_s3-bucket.png";

export const projectsData = [
    {
        id: 1,
        image: Project1,
        title: "To Do List",
        visualizar: "https://github.com/GabrielMorais2/spring-react-todo-app",
        repositorio: "https://github.com/GabrielMorais2/spring-react-todo-app",
        technologies: ['React', 'Java', 'GitHub', 'Docker', 'Chakra', 'TypeScript', 'SpringBoot', 'Postgres'],
    },
    {
        id: 2,
        image: Project2,
        title: "Jogo do número secreto",
        visualizar: "https://jogo-numero-secreto-app.vercel.app/",
        repositorio: "https://github.com/GabrielMorais2/jogo-numero-secreto",
        technologies: ['HTML', 'CSS', 'JavaScript']
    },
    {
        id: 3,
        image: Project3,
        title: "Sistema de Gerenciamento de Corridas - BackEnd",
        visualizar: "https://github.com/GabrielMorais2/project-race-management-system",
        repositorio: "https://github.com/GabrielMorais2/project-race-management-system",
        technologies: ['Java', 'GitHub', 'Docker', 'SpringBoot', 'Postgres'],
    },
    {
        id: 4,
        image: Project4,
        title: "Infraestrutura com terraform e AWS S3",
        visualizar: "https://github.com/GabrielMorais2/infrastructure-terraform-aws",
        repositorio: "https://github.com/GabrielMorais2/infrastructure-terraform-aws",
        technologies: ['AmazonS3', 'TerraForm', 'AWS'],
    }
];
